import { SxProps } from '@mui/material';
import { colors } from 'assets/styles/AMBGTheme';

export const listItemStyle = {
	display: 'flex',
	gap: '5px',
	padding: '10px',
	flexDirection: 'column',
	alignItems: 'flex-start',
	borderRadius: '15px',
	marginBottom: '10px',
	cursor: 'pointer',
	position: 'relative'
} as SxProps;

export const notificationButton = {
	position: 'fixed',
	top: '50%',
	transform: 'translateY(-50%)',
	zIndex: '1201',
	transition: 'right 0.225s ease',
	cursor: 'pointer'
} as SxProps;

export const notificationTitleBox = {
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '10px 20px',
	zIndex: '1',
	width: '100%',
	backgroundColor: colors.white.main
} as SxProps;

export const notificationTitle = {
	fontWeight: '700',
	fontSize: '20px'
} as SxProps;

export const notificationBottomText = {
	display: 'flex',
	justifyContent: 'space-between',
	width: '100%',
	color: colors.secondary.shade5
} as SxProps;
